// API Configuration for Python Functions
const API_CONFIG = {
  // Base URL: use localhost for local dev, empty string for production (relative URLs)
  BASE_URL: window.location.hostname === "localhost"
    ? "http://localhost:8081"
    : "",
  
  // API Endpoints
  ENDPOINTS: {
    GENERATE_SCRIPT: '/api/generate-script',
    REGENERATE_SCRIPT_SECTION: '/api/regenerate-script-section',
    GENERATE_BRIEF: '/api/generate-brief',
    SUBSCRIBE_WAITLIST: '/api/subscribe-waitlist',
    CREATOR_APPLICATION: '/api/creator-application',
    DELETE_CREATOR_APPLICATION: '/api/delete-creator-application',
    APPROVE_CREATOR: '/api/approve-creator',
    RATE_HOOK: '/api/rate-hook',
  GENERATE_HOOK: '/api/generate-hook',
  ENHANCE_CONTENT: '/api/enhance-content',
    // Performance tracking endpoints
    CONNECT_PLATFORM: '/api/connect-platform',
    FETCH_ANALYTICS: '/api/fetch-analytics',
    GENERATE_INSIGHTS: '/api/generate-insights',
    UPDATE_PERFORMANCE: '/api/update-performance',
    
    // Platform Integration endpoints
    CONNECT_META_ADS: '/api/connect-meta-ads',
    FETCH_META_UGC_DATA: '/api/fetch-meta-ugc-data',
    CONNECT_TIKTOK: '/api/connect-tiktok',
    FETCH_TIKTOK_UGC_DATA: '/api/fetch-tiktok-ugc-data',
    ANALYZE_UGC_PERFORMANCE: '/api/analyze-ugc-performance',
    ANALYZE_BRIEF_PERFORMANCE: '/api/analyze-brief-performance',
    ANALYZE_SCRIPT_PERFORMANCE: '/api/analyze-script-performance',
    ANALYZE_CREATOR_PERFORMANCE: '/api/analyze-creator-performance',
    PLATFORM_CONNECTION_STATUS: '/api/platform-connection-status',
    DISCONNECT_PLATFORM: '/api/disconnect-platform',
    
    // Payment endpoints
    CREATE_CHECKOUT_SESSION: '/api/create-checkout-session',
    PAYMENT_WEBHOOK: '/api/payment-webhook',
    GET_CREDIT_PACKAGES: '/api/get-credit-packages',
    TEST_ADD_CREDITS: '/api/test/add-credits',
    
    // Admin endpoints
    GENERATE_BRAND_SIGNUP_TOKEN: '/api/admin/generate-brand-signup-token',
    
    // Brand endpoints
    MARK_TOKEN_USED: '/api/brand/mark-token-used',
    CHECK_INVITE_EMAIL: '/api/brand/check-invite-email',
    APPROVE_CANCELLATION: '/api/brand/approve-cancellation',
    NOTIFY_CREATOR_ASSIGNMENT: '/api/notify-creator-assignment',
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = getApiUrl(endpoint);
  
  // Merge headers properly - ensure Content-Type is always set
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const mergedOptions = {
    ...options,
    headers,
  };

  console.log('🌐 apiCall: Making request to:', url);
  console.log('🌐 apiCall: Method:', mergedOptions.method || 'GET');
  console.log('🌐 apiCall: Headers:', {
    ...headers,
    'Authorization': headers['Authorization'] ? 'Bearer ***' : undefined // Don't log full token
  });

  try {
    const response = await fetch(url, mergedOptions);
    
    console.log('🌐 apiCall: Response status:', response.status, response.statusText);
    console.log('🌐 apiCall: Response headers:', Object.fromEntries(response.headers.entries()));
    
    const responseText = await response.text();
    console.log('🌐 apiCall: Response body (raw):', responseText);
    
    if (!response.ok) {
      console.error('❌ apiCall: HTTP error response:', {
        status: response.status,
        statusText: response.statusText,
        body: responseText
      });
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    let jsonData;
    try {
      jsonData = JSON.parse(responseText);
      console.log('✅ apiCall: Parsed JSON response:', jsonData);
    } catch (parseError) {
      console.error('❌ apiCall: Failed to parse JSON:', parseError);
      throw new Error(`Invalid JSON response: ${responseText.substring(0, 100)}`);
    }
    
    return jsonData;
  } catch (error) {
    console.error('❌ apiCall: Fetch error:', error);
    throw error;
  }
};

export { API_CONFIG };
export default API_CONFIG; 